var map = {
	"./aparthotelclub/ic_tag_status.png": 59523,
	"./beachful/ic_tag_status.png": 65209,
	"./castlepedia/ic_tag_status.png": 33248,
	"./cocktayl/ic_tag_status.png": 15165,
	"./ic_tag_status.png": 71330,
	"./luxresortclub/ic_tag_status.png": 76898,
	"./parkful/ic_tag_status.png": 1287,
	"./prefabworld/ic_tag_status.png": 85766,
	"./rooftopclub/ic_tag_status.png": 65595,
	"./spaclub/ic_tag_status.png": 77581,
	"./worldcasino/ic_tag_status.png": 53731,
	"./zoopedia/ic_tag_status.png": 74899
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30664;